// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"74605a58","408":"bba72b5c"}[chunkId] + ".chunk.js";
};